import { create } from "zustand";
import { combine } from "zustand/middleware";
import type { MobileToolPanelPinId } from "../constants/mobileToolPanelPins";

type MobilePinnedToolPanelState = {
  pinnedPanelId: MobileToolPanelPinId | null;
};

type MobilePinnedToolPanelActions = {
  setPinnedPanelId: (id: MobileToolPanelPinId | null) => void;
  togglePinSelection: (id: MobileToolPanelPinId) => void;
};

export const useMobilePinnedToolPanelStore = create<
  MobilePinnedToolPanelState & { actions: MobilePinnedToolPanelActions }
>()(
  combine(
    {
      pinnedPanelId: null as MobileToolPanelPinId | null,
    },
    (set, get) => ({
      actions: {
        setPinnedPanelId: (pinnedPanelId) => set({ pinnedPanelId }),
        togglePinSelection: (id) => set({ pinnedPanelId: get().pinnedPanelId === id ? null : id }),
      },
    })
  )
);

export function useMobilePinnedToolPanelId() {
  return useMobilePinnedToolPanelStore((s) => s.pinnedPanelId);
}

export function useMobilePinnedToolPanelActions() {
  return useMobilePinnedToolPanelStore((s) => s.actions);
}
